exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#panorama{background:#030a03;width:100%;height:100%;display:flex;flex-direction:column}#panorama .ui.message{margin:8px}#panorama .loading{color:#fefefe;font-size:120%;margin:8px;text-align:center}#panorama .loading .circle.notch{height:20px;width:22px}#panorama .viewer{position:relative;display:flex;width:100%;height:100%}#panorama .viewer .psv-container{background:#030a03}#panorama .viewer .psv-loader{color:#fefefe}#panorama .psv-download-button{display:none}", ""]);

// exports
